var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import { More } from "@epic-ui/icons";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
var styles = function (_a) {
    var spacing = _a.spacing;
    return createStyles({
        paper: {
            transform: "translate(1px, -1px)",
            minWidth: spacing(34),
        },
    });
};
export var OptionsMenu = withStyles(styles, { name: "EuiOptionsMenu" })(React.forwardRef(function OptionsMenu(_a, ref) {
    var onClose = _a.onClose, childrenProp = _a.children, keepOpen = _a.keepOpen, _b = _a.MenuListProps, MenuListProps = _b === void 0 ? {} : _b, openLabel = _a.openLabel, size = _a.size, _c = _a.openButtonProps, _d = _c === void 0 ? {} : _c, onClickOpen = _d.onClick, openButtonProps = __rest(_d, ["onClick"]), props = __rest(_a, ["onClose", "children", "keepOpen", "MenuListProps", "openLabel", "size", "openButtonProps"]);
    var _e = React.useState(false), open = _e[0], setOpen = _e[1];
    var triggerRef = React.useRef(null);
    var handleClose = React.useCallback(function (event, reason) {
        if (reason === void 0) { reason = "backdropClick"; }
        onClose && onClose(event, reason);
        setOpen(false);
    }, [onClose]);
    var handleClickOpen = React.useCallback(function (event) {
        setOpen(true);
        onClickOpen && onClickOpen(event);
    }, [onClickOpen]);
    var positionProps = React.useMemo(function () { return ({
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "right",
        },
    }); }, []);
    // Manages closing menu on clicking item
    var children = keepOpen
        ? childrenProp
        : React.Children.map(childrenProp, function (child) {
            return React.isValidElement(child)
                ? React.cloneElement(child, {
                    onClick: function (event) {
                        child.props.onClick && child.props.onClick(event);
                        handleClose(event);
                    },
                })
                : child;
        });
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, __assign({ "aria-haspopup": "true", "aria-expanded": open ? "true" : undefined, "aria-label": openLabel, ref: triggerRef, onClick: handleClickOpen, size: size }, openButtonProps),
            React.createElement(More, { fontSize: size === "small" ? "small" : undefined })),
        React.createElement(Menu, __assign({ anchorEl: triggerRef.current, open: open, onClose: handleClose, MenuListProps: __assign({}, MenuListProps) }, positionProps, props, { ref: ref }), children)));
}));
//# sourceMappingURL=OptionsMenu.js.map